module.exports = __webpack_public_path__ + "static/media/visa-icon-white-24x12.b91463da.svg";